module.exports = __webpack_public_path__ + "img/banner4.f993bb96.jpg";